import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AuthService, UserService } from 'octali-lib-firebase-utils';
import { DisplayerService } from 'octali-lib-utils';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.page.html',
  styleUrls: ['./reset-password.page.scss'],
})
export class ResetPasswordPage implements OnInit {

  public resetForm: FormGroup;

  constructor(
    private modalCtrl: ModalController,
    private profileService: UserService,
    private displayer:DisplayerService,
    private formBuilder: FormBuilder,
    private authService: AuthService
  ) { 
    this.resetForm = formBuilder.group({
      email: [ '', Validators.required ]
    });
  }

  ngOnInit() {
  }


  async reset(): Promise<void> {
    if (!this.resetForm.valid) 
      return;
    this.authService.passwordReset( this.resetForm.value.email).then( async () => {
      await this.displayer.presentAlert("Mot de passe oublié","email envoyé","Nous vous avons envoyé un email afin de réinitialiser votre mot de passe.");
      this.close();
    });
    //await this.displayer.presentLoader();
    
  }

  async close() {
    const modal = await this.modalCtrl.getTop();
    if(modal)
     modal.dismiss();
  }

  goLogin(){

  }

  goSignup() {

  }

}
